(function () {
  if (window.__sizeGuideModalBound) return;
  window.__sizeGuideModalBound = true;

  const MODAL_ID = 'size-guide-modal';

  function ensureModal() {
    let modal = document.getElementById(MODAL_ID);
    if (modal) return modal;
    modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'size-guide-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('hidden', '');
    modal.innerHTML =
      '<div class="size-guide-modal__backdrop" data-close></div>' +
      '<div class="size-guide-modal__panel" tabindex="-1">' +
        '<div class="size-guide-modal__head">' +
          '<button type="button" class="size-guide-modal__close" aria-label="Close" data-close>' +
            '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="size-guide-modal__body" data-modal-body>' +
          '<div class="size-guide-modal__loading">Loading…</div>' +
        '</div>' +
      '</div>';
    document.body.appendChild(modal);

    modal.querySelectorAll('[data-close]').forEach((el) => {
      el.addEventListener('click', () => closeModal());
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
    return modal;
  }

  function openModal() {
    const modal = ensureModal();
    modal.removeAttribute('hidden');
    document.body.classList.add('size-guide-modal-open');
  }

  function closeModal() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    modal.setAttribute('hidden', '');
    document.body.classList.remove('size-guide-modal-open');
  }

  async function loadIntoModal(url) {
    const modal = ensureModal();
    const body = modal.querySelector('[data-modal-body]');
    body.innerHTML = '<div class="size-guide-modal__loading">Loading…</div>';
    openModal();
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');

      const wrapper = doc.querySelector('.shopify-section.section-size-guide')
        || doc.querySelector('.section-size-guide')
        || doc.querySelector('[id^="shopify-section"] size-guide')?.closest('[id^="shopify-section"]')
        || doc.querySelector('size-guide');

      if (!wrapper) {
        body.innerHTML = '<p class="size-guide-modal__error">Couldn\'t load the size guide.</p>';
        return;
      }

      body.innerHTML = '';
      body.appendChild(wrapper.cloneNode(true));

      body.querySelectorAll('size-guide').forEach((el) => {
        try { customElements.upgrade(el); } catch (e) { /* ignore */ }
      });

      // Re-execute inline <script> tags (innerHTML/cloneNode doesn't run them).
      body.querySelectorAll('script').forEach((oldScript) => {
        const newScript = document.createElement('script');
        Array.from(oldScript.attributes).forEach((attr) => newScript.setAttribute(attr.name, attr.value));
        newScript.textContent = oldScript.textContent;
        oldScript.parentNode.replaceChild(newScript, oldScript);
      });

      // Mouse-drag support on the model wears carousel inside the modal
      body.querySelectorAll('[data-models-grid]').forEach((grid) => {
        let isDown = false, startX = 0, startScroll = 0, moved = false;
        grid.addEventListener('mousedown', (e) => {
          isDown = true; moved = false;
          startX = e.pageX - grid.offsetLeft;
          startScroll = grid.scrollLeft;
          grid.style.cursor = 'grabbing';
          grid.style.userSelect = 'none';
        });
        grid.addEventListener('mouseleave', () => { isDown = false; grid.style.cursor = ''; grid.style.userSelect = ''; });
        grid.addEventListener('mouseup', () => { isDown = false; grid.style.cursor = ''; grid.style.userSelect = ''; });
        grid.addEventListener('mousemove', (e) => {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX - grid.offsetLeft;
          const walk = (x - startX) * 1.2;
          if (Math.abs(walk) > 3) moved = true;
          grid.scrollLeft = startScroll - walk;
        });
        grid.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
        grid.style.cursor = 'grab';
      });
    } catch (e) {
      body.innerHTML = '<p class="size-guide-modal__error">Couldn\'t load the size guide.</p>';
    }
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-size-guide-modal]');
    if (!trigger) return;
    e.preventDefault();
    const url = trigger.getAttribute('href') || trigger.getAttribute('data-size-guide-url');
    if (!url) return;
    loadIntoModal(url);
  });
})();
